import React, { useEffect } from "react";
import { Form, Input, Button, DatePicker, Row, Col, Spin } from "antd";
import { ReactSVG } from "react-svg";
import { useSelector } from "react-redux";

import { DATE_FORMAT_FRONTEND, DATE_FORMAT_QUERY } from "../../../constants";
import { getTranslation } from "../../../utils/helper";
import dayjs from "dayjs";

const ReportsFilterForm = ({ isFetching, query, onSubmit, isOther }) => {
  const user = useSelector(state => state.auth.user);
  const setting = useSelector(state => state.setting.setting) || user?.company;
  const roles = user?.roles || [];

  const [form] = Form.useForm();

  const orderCodeField = "orderCode";
  const orderCodeValue = query[orderCodeField];

  const pickupNameField = "pickupName";
  const pickupNameValue = query[pickupNameField];

  const pickupAddressField = "pickupAddress";
  const pickupAddressValue = query[pickupAddressField];

  const pickupPhoneField = "pickupPhone";
  const pickupPhoneValue = query[pickupPhoneField];

  const deliveryNameField = "deliveryName";
  const deliveryNameValue = query[deliveryNameField];

  const deliveryAddressField = "deliveryAddress";
  const deliveryAddressValue = query[deliveryAddressField];

  const deliveryPhoneField = "deliveryPhone";
  const deliveryPhoneValue = query[deliveryPhoneField];

  const routePlanNameField = "routePlanName";
  const routePlanNameValue = query[routePlanNameField];

  const startDateField = "startDate";
  const startDateValue = query[startDateField];

  const endDateField = "endDate";
  const endDateValue = query[endDateField];

  const companyEmailField = "companyEmail";
  const companyEmailValue = query[companyEmailField];

  useEffect(() => {
    form.setFieldsValue(initialValues());
  }, [query]);

  const initialValues = () => {
    const values = {};
    if (!isOther) {
      values[orderCodeField] = orderCodeValue;
      values[pickupNameField] = pickupNameValue;
      values[pickupAddressField] = pickupAddressValue;
      values[pickupPhoneField] = pickupPhoneValue;
      values[deliveryNameField] = deliveryNameValue;
      values[deliveryAddressField] = deliveryAddressValue;
      values[deliveryPhoneField] = deliveryPhoneValue;
      values[routePlanNameField] = routePlanNameValue;
    }
    values[startDateField] = startDateValue && dayjs(startDateValue, DATE_FORMAT_QUERY);
    values[endDateField] = endDateValue && dayjs(endDateValue, DATE_FORMAT_QUERY);
    if (roles.includes("admin")) values[companyEmailField] = companyEmailValue;
    return values;
  };

  const handleSubmit = values => {
    const params = {};
    if (!isOther) {
      params[orderCodeField] = values[orderCodeField] || null;
      params[pickupNameField] = values[pickupNameField] || null;
      params[pickupAddressField] = values[pickupAddressField] || null;
      params[pickupPhoneField] = values[pickupPhoneField]?.replace("+", "") || null;
      params[deliveryNameField] = values[deliveryNameField] || null;
      params[deliveryAddressField] = values[deliveryAddressField] || null;
      params[deliveryPhoneField] = values[deliveryPhoneField] || null;
      params[routePlanNameField] = values[routePlanNameField] || null;
    }

    params[startDateField] = (values[startDateField] && values[startDateField].format(DATE_FORMAT_QUERY)) || null;
    params[endDateField] = (values[endDateField] && values[endDateField].format(DATE_FORMAT_QUERY)) || null;
    if (roles.includes("admin")) params[companyEmailField] = values[companyEmailField] || null;
    onSubmit({ ...query, ...params, currentPage: 1 }, true);
  };

  const handleResetButton = () => {
    onSubmit({}, true);
    form.resetFields();
  };

  return (
    <Spin spinning={isFetching}>
      <Form
        form={form}
        onFinish={handleSubmit}
        initialValues={initialValues}
        className="FilterForm ReportsFilterForm"
        layout="vertical">
        <div className="FilterFormContent">
          <Row gutter={16}>
            {!isOther && (
              <Col xs={{ span: 24 }} md={{ span: 8 }}>
                <Form.Item label={getTranslation(setting, "Orders", "Order ID")} name={orderCodeField}>
                  <Input size="large" placeholder={getTranslation(setting, "Orders", "Order ID")} />
                </Form.Item>
              </Col>
            )}
            <Col xs={{ span: 24 }} md={{ span: 8 }}>
              <Form.Item label={getTranslation(setting, "Orders", "Start Date")} name={startDateField}>
                <DatePicker
                  size="large"
                  format={DATE_FORMAT_FRONTEND}
                  placeholder={getTranslation(setting, "Orders", "Delivery Date")}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} md={{ span: 8 }}>
              <Form.Item label={getTranslation(setting, "Orders", "End Date")} name={endDateField}>
                <DatePicker
                  size="large"
                  format={DATE_FORMAT_FRONTEND}
                  placeholder={getTranslation(setting, "Orders", "Delivery Date")}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            {!isOther && (
              <Col xs={{ span: 24 }} md={{ span: 8 }}>
                <Form.Item label={getTranslation(setting, "Orders", "Delivery Name")} name={deliveryNameField}>
                  <Input size="large" placeholder={getTranslation(setting, "Orders", "Delivery Name")} />
                </Form.Item>
              </Col>
            )}
            {!isOther && (
              <Col xs={{ span: 24 }} md={{ span: 8 }}>
                <Form.Item label={getTranslation(setting, "Orders", "Delivery Address")} name={deliveryAddressField}>
                  <Input size="large" placeholder={getTranslation(setting, "Orders", "Delivery Address")} />
                </Form.Item>
              </Col>
            )}
            {!isOther && (
              <Col xs={{ span: 24 }} md={{ span: 8 }}>
                <Form.Item label={getTranslation(setting, "Orders", "Delivery Phone")} name={deliveryPhoneField}>
                  <Input size="large" placeholder={getTranslation(setting, "Orders", "Delivery Phone")} />
                </Form.Item>
              </Col>
            )}

            {!isOther && (
              <Col xs={{ span: 24 }} md={{ span: 8 }}>
                <Form.Item label={getTranslation(setting, "Orders", "Route Plan Name")} name={routePlanNameField}>
                  <Input size="large" placeholder={getTranslation(setting, "Orders", "Route Plan Name")} />
                </Form.Item>
              </Col>
            )}
            {roles.includes("admin") && (
              <Col xs={{ span: 24 }} md={{ span: 8 }}>
                <Form.Item label="Company Admin Email" name={companyEmailField}>
                  <Input size="large" placeholder="Company Admin Email" />
                </Form.Item>
              </Col>
            )}
          </Row>
        </div>
        <div className="FilterFormActions">
          <Button size="large" type="text" onClick={handleResetButton}>
            {getTranslation(setting, "Common", "Reset")}
            <ReactSVG className="icon" src="/icons/reset.svg" />
          </Button>
          <Button size="large" type="primary" htmlType="submit">
            {getTranslation(setting, "Common", "Apply")}
            <ReactSVG className="icon" src="/icons/apply.svg" />
          </Button>
        </div>
      </Form>
    </Spin>
  );
};

export default ReportsFilterForm;
